import React from 'react';
import { Route } from 'react-router-dom';

export class Analytics extends React.Component {
  /**
   * When the component is mounted - trigger it to send a page view
   * @returns {void}
   */
  componentDidMount() {
    this.sendPageChange(this.props.location.pathname, this.props.location.search);
  }

  /**
   *
   * @param {object} prevProps the previous properties
   * @returns {void}
   */
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname || this.props.location.search !== prevProps.location.search) {
      this.sendPageChange(this.props.location.pathname, this.props.location.search);
    }
  }

  /**
   * combines and sends to the google library the pageView
   * @param {string} pathname of the current url string
   * @param {string} search search params from the url
   * @returns {void}
   */
  sendPageChange(pathname, search = '') {
    const page = pathname + search;
    if (typeof window.ga !== 'undefined') {
      window.ga('send', 'pageview', page);
    }
  }

  /**
   * We need a render for the compment, however we are not going to render anything from here
   * @returns {void}
   */
  render() {
    return null;
  }
}

/**
 * If not plugged into the router - could use this (ie if within a layout wrapper)
 * @returns {Analytics} component
 */
const AnalyticsTracker = () => {
  return <Route component={Analytics} />;
};

export default AnalyticsTracker;
